"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 15.82c-3.84 0-7.16-2.86-7.73-6.66L.1 8.04l.94.63c.91.6 1.96.92 3.05.92 3.03 0 5.5-2.47 5.5-5.5 0-1.09-.32-2.14-.92-3.05L8.04.1l1.12.17c3.79.57 6.66 3.89 6.66 7.73h-1c0-2.98-1.98-5.61-4.76-6.49.35.81.54 1.69.54 2.59 0 3.59-2.92 6.5-6.5 6.5-.9 0-1.78-.18-2.59-.54.89 2.78 3.51 4.76 6.49 4.76 3.31 0 6.14-2.36 6.72-5.62l.98.17A7.803 7.803 0 0 1 8 15.81v.01Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.008 23.543c-5.663 0-10.568-4.223-11.4-9.825l-.188-1.26 1.057.704a8.377 8.377 0 0 0 4.68 1.418c4.658 0 8.445-3.787 8.445-8.445a8.377 8.377 0 0 0-1.417-4.68L12.48.397l1.26.188c5.603.84 9.825 5.745 9.825 11.4H22.44c0-4.695-3.225-8.82-7.673-10.035a9.55 9.55 0 0 1 .96 4.177c0 5.273-4.29 9.57-9.57 9.57a9.506 9.506 0 0 1-4.177-.96c1.223 4.448 5.34 7.673 10.035 7.673a10.4 10.4 0 0 0 10.26-8.58l1.11.195a11.523 11.523 0 0 1-11.363 9.51l-.014.008Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.01 31.39c-7.55 0-14.09-5.63-15.2-13.1l-.25-1.68 1.41.94c1.85 1.24 4.01 1.89 6.24 1.89 6.21 0 11.26-5.05 11.26-11.26 0-2.23-.65-4.39-1.89-6.24L16.64.53l1.68.25c7.47 1.12 13.1 7.66 13.1 15.2h-1.5c0-6.26-4.3-11.76-10.23-13.38a12.74 12.74 0 0 1 1.28 5.57c0 7.03-5.72 12.76-12.76 12.76-1.95 0-3.85-.44-5.57-1.28 1.63 5.93 7.12 10.23 13.38 10.23 6.75 0 12.5-4.81 13.68-11.44l1.48.26a15.365 15.365 0 0 1-15.15 12.68l-.02.01Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.008 46.905c-11.235 0-20.955-8.377-22.62-19.492l-.315-2.093 1.762 1.177a16.977 16.977 0 0 0 9.457 2.866c9.413 0 17.07-7.658 17.07-17.07 0-3.383-.99-6.653-2.864-9.458L25.32 1.073l2.093.315C38.52 3.053 46.904 12.78 46.904 24.008H45.03c0-9.623-6.697-18.038-15.885-20.363a18.842 18.842 0 0 1 2.093 8.648c0 10.447-8.498 18.945-18.945 18.945-3.03 0-5.985-.72-8.648-2.093C5.97 38.333 14.385 45.03 24.007 45.03c10.208 0 18.915-7.282 20.7-17.318l1.846.33C44.61 38.97 35.123 46.906 24.008 46.906Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    d: "M32.01 62.54c-14.98 0-27.94-11.17-30.16-25.99l-.42-2.79 2.35 1.57c3.74 2.5 8.11 3.82 12.61 3.82 12.55 0 22.76-10.21 22.76-22.76 0-4.51-1.32-8.87-3.82-12.61l-1.57-2.35 2.79.42c14.81 2.22 25.99 15.19 25.99 30.16h-2.5c0-12.83-8.93-24.05-21.18-27.15 1.83 3.55 2.79 7.49 2.79 11.53 0 13.93-11.33 25.26-25.26 25.26-4.04 0-7.98-.96-11.53-2.79 3.1 12.25 14.32 21.18 27.15 21.18 13.61 0 25.22-9.71 27.6-23.09l2.46.44c-2.59 14.57-15.24 25.15-30.06 25.15Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconMoon = function IconMoon(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Moon' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Moon"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconMoon.sizes = [16, 24, 32, 48, 64];
IconMoon.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconMoon;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/system/Moon.js
// module id = 2424
// module chunks = 0